import React, { useContext } from "react"

import Spacer from "@p-ban/common/src/components/layout/Spacer"

import MANUFACTURE_COURSE, { type ManufactureCourse } from "../../../../../constant/manufactureCourse"
import estimateField from "../../../../../service/estimateFields/estimateField"
import OneClickEstimateContext from "../../../../OneClickEstimateContext"
import CourseOptionContainer from "../../../../components/1Click/result/CourseOptionContainer"
import CheckBox from "../../../../components/1Click/result/form/CheckBox"
import LINKS from "../../../../constant/links"

type Props = {
  isShow: boolean
  manufactureCourse: ManufactureCourse
  selectedManufactureCourse: ManufactureCourse
}

const デリバリーゼロ = ({ isShow, manufactureCourse, selectedManufactureCourse }: Props) => {
  const { deliveryZeroFlg, setDeliveryZeroFlg } = useContext(OneClickEstimateContext)
  const { setManufactureCourse } = useContext(OneClickEstimateContext)
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setDeliveryZeroFlg(e.target.checked)

  // エラーは起きない前提のため、エラーメッセージの表示欄は未実装
  return (
    <CourseOptionContainer isShow={isShow} helpURL={LINKS.DELIVERY_ZERO}>
      <Spacer size={12} />
      <CheckBox
        name={estimateField.deliveryZeroFlg.displayName()}
        checked={deliveryZeroFlg}
        disabled={selectedManufactureCourse !== MANUFACTURE_COURSE.ultraQuick}
        onChange={(e) => {
          setManufactureCourse(manufactureCourse)
          onChange(e)
        }}
        labelClickable={false}
      >
        <Spacer size={12} />
        <span className="text-charcoal-gray">{estimateField.deliveryZeroFlg.displayName()}</span>
      </CheckBox>
    </CourseOptionContainer>
  )
}

export default デリバリーゼロ
